/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { format } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale';

import { useAuth } from 'context/AuthContext';

import { genConfig } from 'funifier-nice-avatar';

import './style.scss';
import { BiInfoCircle } from 'react-icons/bi';
import { useLocation, useNavigate } from 'react-router-dom';
import { SeloHelpModal } from 'components/selo-help-modal';
import { useModal } from 'context/ModalContext';
import {
  Colaboracao,
  FocoNoCliente,
  Inovacao,
  Resolutividade,
  Lideranca,
  SeloColaboracao,
  SeloFocoNoCliente,
  SeloInovacao,
  SeloResolutividade,
} from 'components/icons';
import { SeloMoedasModal } from 'components/moeda-help-modal';
import { NotAllowed } from 'pages/NotAllowed';
import { getKPIPointsOnline, getKPIPontosCultura, getPlayerInfo, getResultadosByUser } from 'services/dashboard.service';
import { ComportamentoHelpModal } from 'components/comportamento-help-modal';
import { PontosHelpModal } from 'components/pontos-help-modal';
import Tippy from '@tippyjs/react';
import { RankingKPI } from 'types/user';

import { getChallenges } from 'services/challenges.service';
import UserTutorial from 'components/user-tutorial';
import { getAllNotifications } from 'services/notifications.service';
import { useWebsocketNotification } from 'context/WebsocketNotificationContext';
import NewFeatures from 'components/new-features';
import { GroupDetailModal } from 'components/group-detail-modal';
import { UserInfo } from 'types/user';
import { useMsal } from '@azure/msal-react';

const defautConfig = genConfig();

const dummyRankingKPI = { position: 0, total_positions: 0 };
const dummyKPI: any = {
  position: '---',
  uau: '---',
  mandou: '---',
  valeu: '---',
};

const behaviors: any = {
  colaboracao: {
    id: 'colaboracao',
    icon: <SeloColaboracao size={'40px'} />,
  },
  foco: {
    id: 'foco',
    icon: <SeloFocoNoCliente size={'40px'} />,
  },
  inovacao: {
    id: 'inovacao',
    icon: <SeloInovacao size={'40px'} />,
  },
  resolutividade: {
    id: 'resolutividade',
    icon: <SeloResolutividade size={'40px'} />,
  },
};

interface Props {
  filter?: any;
}

const Dimensions = (data: Props) => {
  const { user, refreshUser, signOut, currentCycle, isMSTeams } = useAuth();
  const { setMessage } = useWebsocketNotification();
  const [avatarConfig, setAvatarConfig] = useState(defautConfig);
  const [isGestor, setIsGestor] = useState(false);
  const [groupInfo, setGroupInfo] = useState<any>();
  const [userInfo, setUserInfo] = useState<UserInfo>();
  const [lastUpdate, setLastUpdate] = useState<any>();
  const [resultadoCultura, setResultadoCultura] = useState<string>();
  const [load, setLoad] = useState(true);
  const { instance } = useMsal();

  const [selosBB, setSelosBB] = useState<any>();

  const [showTutorial, setShowTutorial] = useState(false);
  const [closeFeatures, setCloseFeatures] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { showModal } = useModal();

  const [destaqueCultura, setDestaqueCultura] = useState({
    foco: dummyKPI,
    colaboracao: dummyKPI,
    inovacao: dummyKPI,
    resolutividade: dummyKPI,
    lideranca: dummyKPI,
  });

  const [pontosCultura, setPontosCultura] = useState<{
    foco: number;
    colaboracao: number;
    inovacao: number;
    resolutividade: number;
    lideranca: number;
    total: number;
    geral: number;
    ranking_galeria: any;
  }>({
    foco: 0,
    colaboracao: 0,
    inovacao: 0,
    resolutividade: 0,
    lideranca: 0,
    total: 0,
    geral: 0,
    ranking_galeria: undefined,
  });

  const [galeriaReconhecimento, setGaleriaReconhecimento] = useState<RankingKPI>(dummyRankingKPI);

  // useEffect(() => {
  //   console.log(data);
  // }, [data]);

  function handleNavMobile() {
    document.dispatchEvent(new CustomEvent('openNavMobile'));
  }

  function getPositionCulturaLabel(kpi: any) {
    try {
      return (
        <div className="p-1 text-center">
          <p>
            Você está na colocação <b>{kpi.posicao}</b> de <b>{groupInfo.total}</b> dentro do seu grupo.{' '}
            {!!lastUpdate
              ? `Ranking atualizado em: ${format(new Date(lastUpdate), 'd MMM yyyy, HH:mm', {
                  locale: ptBR,
                })}.`
              : ''}
          </p>

          <p>
            Estarão na lista final desta mecânica "Destaques da Cultura" 5% dos participantes dentro do seu grupo, com
            arredondamento para cima, que receberem mais pontos em cada Comportamento da Cultura.
          </p>

          <p>A divulgação dos ganhadores será realizada por ordem alfabética.</p>
          <p>A sua posição nesta mecânica está visível somente a você.</p>
        </div>
      );
    } catch (e) {
      return `---`;
    }
  }

  useEffect(() => {
    try {
      const locationState: any = location.state;
      if (locationState && locationState.direction) {
        if (locationState.direction === 'back') {
          refreshUser();
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [location]);

  useEffect(() => {
    async function loadKPIComportamento() {
      try {
        const resultPointsOnline = await getKPIPointsOnline(user?._id, data.filter);

        const _pontosCultura: any = {
          foco: 0,
          colaboracao: 0,
          inovacao: 0,
          resolutividade: 0,
          lideranca: 0,
          total: resultPointsOnline.total || 0,
          geral: resultPointsOnline.geral || 0,
          ranking_galeria: !!resultPointsOnline.ranking_galeria ? resultPointsOnline.ranking_galeria : undefined,
        };

        resultPointsOnline.positions?.forEach((position: any) => {
          _pontosCultura[position.behavior] = position.total;
        });

        setPontosCultura(_pontosCultura);

        const kpiPontosCultura = await getKPIPontosCultura(user?._id, data.filter);
        setGaleriaReconhecimento({
          position: !!resultPointsOnline?.ranking_galeria?.position ? resultPointsOnline?.ranking_galeria?.position : 0,
          total: !!resultPointsOnline.geral ? resultPointsOnline.geral : 0,
        });
        setLastUpdate(kpiPontosCultura?.time || undefined);

        if (!!kpiPontosCultura?.positions?.length) {
          const _destaqueCultura: any = {
            foco: { posicao: '---' },
            colaboracao: { posicao: '---' },
            inovacao: { posicao: '---' },
            resolutividade: { posicao: '---' },
            lideranca: { posicao: '---' },
          };

          kpiPontosCultura.positions.forEach((position: any) => {
            _destaqueCultura[position.behavior].posicao = position.position;
          });

          setDestaqueCultura(_destaqueCultura);
        }
      } catch (e) {
        console.log(e);
      }
    }

    function updateAvatar() {
      if (user?.extra.avatar) {
        setAvatarConfig(user?.extra.avatar);
      }
    }

    async function getUserInfo() {
      try {
        const playerInfo = await getPlayerInfo(user?._id);

        if (playerInfo) {
          setUserInfo(playerInfo);
          setIsGestor(playerInfo.tipo_ro === 'GERENCIAL' || playerInfo.funcao === 'DIRETOR');

          if (playerInfo.grupo) {
            setGroupInfo({
              ro: playerInfo.ro,
              ...playerInfo.grupo,
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
    }

    function shouldShowTutorial() {
      if ((user?.extra.accept && !user?.extra.tutorial) || !localStorage.getItem('tutorial')) {
        setShowTutorial(true);
      }
    }

    async function loadChallenges() {
      try {
        const data = await getChallenges(`'extra.type':'selobb'`);
        const currentSelosBB = data.filter((item: any) => {
          return user?.challenges[item._id] >= 1;
        });
        setSelosBB(currentSelosBB);
      } catch (e) {}
    }

    async function loadResultadoCultura() {
      if (user?._id) {
        const data = await getResultadosByUser(user?._id);

        if (data && data.length > 0) setResultadoCultura(data[0].behavior);
        setLoad(false);
      }
    }

    if (!user || !currentCycle) return;

    loadChallenges();
    loadKPIComportamento();
    updateAvatar();
    getUserInfo();
    shouldShowTutorial();
    loadResultadoCultura();

    const returnURL = sessionStorage.getItem('return');

    if (returnURL) {
      sessionStorage.removeItem('return');
      navigate(returnURL);
    }
  }, [user, currentCycle, data]);

  function handleLogout() {
    instance.logoutRedirect({
      onRedirectNavigate: () => false,
    });
  }

  useEffect(() => {
    async function loadNotifications() {
      if (userInfo) {
        const data = await getAllNotifications(userInfo?.cad_missao, user?.extra?.lastMessage);
        setMessage(data);
      }
    }

    if (!userInfo || !user) return;

    loadNotifications();
  }, [userInfo, user]);

  if (!user) return null;

  if (!user.extra.id) {
    return <NotAllowed />;
  }

  return (
    <>
      <>
        <div
          data-step="4"
          className="mt-8 border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-row items-center justify-between"
        >
          <div className="w-full">
            <p className="font-light mb-8 lg:mb-0 text-left block" tabIndex={0}>
              Acompanhe suas Pontos recebidas em cada comportamento dentro dos{' '}
              <span className="text-yellow">Destaques da Cultura</span>
            </p>

            <div className="grid grid-cols-1 gap-8 lg:flex lg:flex-row items-start lg:items-center justify-between lg:mt-5 lg:px-10">
              <div
                className={`${
                  !pontosCultura.colaboracao || pontosCultura.colaboracao <= 0 ? 'opacity-60' : ''
                } text-center flex items-center`}
                tabIndex={0}
              >
                {/* <Tippy
                  arrow={false}
                  className="bg-blue-light drop-shadow-lg text-blue-dark"
                  allowHTML={true}
                  content={getPositionCulturaLabel(destaqueCultura.colaboracao)}
                >
                  <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                    {destaqueCultura.colaboracao.posicao
                      ? `${destaqueCultura.colaboracao.posicao}º`
                      : '---'}
                    <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                  </b>
                </Tippy> */}
                <div
                  onClick={() => showModal('comportamento-help', 'colaboracao')}
                  className="hover:ring-4 cursor-pointer h-24 w-24 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                >
                  <Colaboracao size={'100%'} />
                </div>
                <div className="flex flex-col ml-4">
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">COLABORAÇÃO</b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin">
                      <b className="mr-1 text-electric-blue">{pontosCultura.colaboracao} Pts</b>
                    </span>
                  </div>
                </div>
              </div>

              <div
                className={`${
                  !pontosCultura.inovacao || pontosCultura.inovacao <= 0 ? 'opacity-60' : ''
                } text-center flex items-center`}
                tabIndex={0}
              >
                {/* <Tippy
                  arrow={false}
                  className="bg-blue-light drop-shadow-lg text-blue-dark"
                  allowHTML={true}
                  content={getPositionCulturaLabel(destaqueCultura.inovacao)}
                >
                  <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                    {destaqueCultura.inovacao.posicao
                      ? `${destaqueCultura.inovacao.posicao}º`
                      : '---'}
                    <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                  </b>
                </Tippy> */}
                <div
                  onClick={() => showModal('comportamento-help', 'inovacao')}
                  className="hover:ring-4 cursor-pointer h-24 w-24 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                >
                  <Inovacao size={'100%'} />
                </div>
                <div className="flex flex-col ml-4">
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">INOVAÇÃO</b>
                  <div className="bg-maastricht-blue text-electric-blue p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin ">
                      <b className="mr-1">{pontosCultura.inovacao}</b> Pts
                    </span>
                  </div>
                </div>
              </div>

              <div
                className={`${!pontosCultura.foco || pontosCultura.foco <= 0 ? 'opacity-60' : ''} text-center flex items-center`}
                tabIndex={0}
              >
                {/* <Tippy
                  arrow={false}
                  className="bg-blue-light drop-shadow-lg text-blue-dark"
                  allowHTML={true}
                  content={getPositionCulturaLabel(destaqueCultura.foco)}
                >
                  <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                    {destaqueCultura.foco.posicao
                      ? `${destaqueCultura.foco.posicao}º`
                      : '---'}
                    <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                  </b>
                </Tippy> */}
                <div
                  onClick={() => showModal('comportamento-help', 'foco')}
                  className="hover:ring-4 cursor-pointer h-24 w-24  overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                >
                  <FocoNoCliente size={'100%'} />
                </div>
                <div className="flex flex-col ml-4">
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">FOCO NO CLIENTE</b>
                  <div className="bg-maastricht-blue  p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin text-electric-blue ">
                      <b className="mr-1">{pontosCultura.foco}</b> Pts
                    </span>
                  </div>
                </div>
              </div>

              <div
                className={`${
                  !pontosCultura.resolutividade || pontosCultura.resolutividade <= 0 ? 'opacity-60' : ''
                } text-center flex items-center`}
                tabIndex={0}
              >
                <div
                  onClick={() => showModal('comportamento-help', 'resolutividade')}
                  className="hover:ring-4 cursor-pointer h-24 w-24  overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                >
                  <Resolutividade size={'100%'} />
                </div>
                <div className="flex flex-col ml-4">
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">PROATIVIDADE</b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin text-electric-blue">
                      <b className="mr-1">{pontosCultura.resolutividade}</b> Pts
                    </span>
                  </div>
                </div>
              </div>

              <div
                className={`${
                  !pontosCultura.lideranca || pontosCultura.lideranca <= 0 ? 'opacity-60' : ''
                } text-center flex items-center`}
                tabIndex={0}
              >
                <div
                  onClick={() => showModal('comportamento-help', 'lideranca')}
                  className="hover:ring-4 cursor-pointer h-24 w-24  overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                >
                  <Lideranca size={'100%'} />
                </div>
                <div className="flex flex-col ml-4">
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">LIDERANÇA ENGAJADORA</b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin text-electric-blue">
                      <b className="mr-1">{pontosCultura.lideranca}</b> Pts
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      {userInfo && <NewFeatures player={userInfo} send={() => setCloseFeatures(true)} />}
      <ComportamentoHelpModal />
      {/* <SeloHelpModal /> */}
      <SeloMoedasModal />
      <PontosHelpModal />
      <GroupDetailModal group={groupInfo} />
    </>
  );
};

export default Dimensions;
